import { render, staticRenderFns } from "./HotelForm.vue?vue&type=template&id=b27603d4&scoped=true&"
import script from "./HotelForm.vue?vue&type=script&lang=js&"
export * from "./HotelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27603d4",
  null
  
)

export default component.exports